export default {
    manage_deleteAsset_title: "Eliminar Activo",
    manage_deleteAssets_title: "Eliminar Activos",
    manage_deleteAssets_description: "¿Estás seguro de que deseas eliminar estos activos?",
    manage_deleteAsset_description: "¿Estás seguro de que deseas eliminar este activo?",
    manage_deleteAsset_successMessage: "Activo eliminado",
    manage_deleteAssets_successMessage: "Activos eliminados",
    manage_deleteAssets_are_in_use: "No es posible eliminar activos que están en uso",
    manage_deleteAssets_successMessageUpdate: "Los activos se han eliminado correctamente",
    manage_deleteAsset_successMessageUpdate: "El activo se ha eliminado correctamente",
}